import axios from 'axios';
import Vue from 'vue'

export default {

    findAllPlane () {
        return axios.get('/api/plane/all-plane')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    findPlaneByName (title) {
        return axios.get('/api/plane/plane-by-title', { params: {title: title} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    sendRequestQuote(formData, requestQuoteDTO) {

        formData.append('requestQuoteDTO', new Blob([JSON.stringify(requestQuoteDTO)], {
            type: 'application/json'
        }));
    
        return axios.post('/api/plane/save/request-quote', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success("Votre demande a été bien envoyée. Nous vous contacterons dans les plus brefs délais.");

                return response.data;
            }
        })
        .catch(error => {
            Vue.prototype.$snotify.error(error);
        });
    },

    findRequestQuote(page, pageSize, start, end ) {
        return axios.get('/api/plane/list/request-quote', { params: {page: page, pageSize: pageSize, start:start, end:end} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },


}